import type { ReactNode } from "react";

export type CardSize = "xs" | "sm" | "md";

const SIZE_CLASSES: Record<CardSize, string> = {
  xs: "rounded-xl p-2.5",
  sm: "rounded-xl p-3",
  md: "rounded-2xl p-4",
};

export interface CardProps {
  children: ReactNode;

  size?: CardSize;

  interactive?: boolean;

  hoverShadow?: boolean;

  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export function Card({
  children,
  size = "sm",
  interactive,
  hoverShadow = true,
  onClick,
  disabled = false,
  className = "",
}: Readonly<CardProps>) {
  const isInteractive = interactive ?? Boolean(onClick);

  const classes = [
    "border border-border-default bg-surface-primary text-left transition-all",
    SIZE_CLASSES[size],
    isInteractive ? "hover:border-content-tertiary" : "shadow-sm",
    isInteractive && hoverShadow ? "hover:shadow-sm" : "",
    disabled ? "cursor-not-allowed opacity-50" : onClick ? "cursor-pointer" : "",
    className,
  ].join(" ");

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={["w-full", classes, "btn-focus-ring"].join(" ")}
      >
        {children}
      </button>
    );
  }

  return <div className={classes}>{children}</div>;
}
